import { Action } from '@ngrx/store';
import { Injectable } from '@angular/core';

import { BaseEntity } from '../models/base';
import { PageInfo } from './../providers/api/api';

/**
 * Generic actions for a list of serializable objects.
 * Objects must be of type Serializable with a prepopulated uid field.
 */

@Injectable()
export class CollectionActions {
  static SET = 'SET';
  set(collectionName: string, items: BaseEntity[]): NamedAction {
    return {
      type: CollectionActions.SET,
      payload: items,
      collectionName: collectionName,
    };
  }

  static APPEND = 'APPEND';
  append(collectionName: string, items: BaseEntity[]): NamedAction {
    return {
      type: CollectionActions.APPEND,
      payload: items,
      collectionName: collectionName,
    };
  }

  static ADD = 'ADD';
  add(collectionName: string, item: BaseEntity): NamedAction {
    return {
      type: CollectionActions.ADD,
      payload: item,
      collectionName: collectionName,
    };
  }

  static INSERT = 'INSERT';
  insert(collectionName: string, item: BaseEntity): NamedAction {
    return {
      type: CollectionActions.INSERT,
      payload: item,
      collectionName: collectionName,
    };
  }

  static UPDATE = 'UPDATE';
  update(collectionName: string, item: BaseEntity): NamedAction {
    return {
      type: CollectionActions.UPDATE,
      payload: item,
      collectionName: collectionName,
    };
  }

  static SET_LOADING = 'SET_LOADING';
  setLoading(collectionName: string, loading: boolean): NamedAction {
    return {
      type: CollectionActions.SET_LOADING,
      payload: loading,
      collectionName: collectionName,
    };
  }

  static SET_WITH_PAGE_INFO = 'SET_WITH_PAGE_INFO';
  setWithPageInfo(collectionName: string, pagedItems: PagedItems): NamedAction {
    return {
      type: CollectionActions.SET_WITH_PAGE_INFO,
      payload: pagedItems,
      collectionName: collectionName,
    };
  }

  static DELETE = 'DELETE';
  delete(collectionName: string, item: BaseEntity): NamedAction {
    return {
      type: CollectionActions.DELETE,
      payload: item,
      collectionName: collectionName,
    };
  }

  static CLEAR_ALL = 'CLEAR_ALL';
  clearAll(): Action {
    return {
      type: CollectionActions.CLEAR_ALL,
    };
  }
}

export interface NamedAction extends Action {
  collectionName: string;
  payload?: any;
}

export interface PagedItems {
  items: BaseEntity[];
  pageInfo: PageInfo;
}



// WEBPACK FOOTER //
// ./src/state/actions.ts